import React from "react";
import { IoMailOutline } from "react-icons/io5";
import IconComponent from "../../../components/common/IconComponent";
import ShadowCard from "../../../components/common/ShadowCard";

const MailIcon = IoMailOutline as any;

interface BulkEmailHeaderProps {
  selectedCount?: number;
  selectedTemplateSubject?: string;
  isSendAccess?: boolean;
}

export const BulkEmailHeader: React.FC<BulkEmailHeaderProps> = () => {
  return (
    <ShadowCard
      style={{
        background: "linear-gradient(135deg, #174583 0%, #174583 100%)",
        borderRadius: "16px",
        padding: "16px 24px",
        marginBottom: "20px",
        color: "#ffffff",
        display: "flex",
        alignItems: "start",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: "16px",
      }}
    >
      {/* Left side: Back Button & Title */}
      <div style={{ display: "flex", alignItems: "start", gap: "14px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <div
            style={{
              padding: "10px 10px 10px 5px",
              borderRadius: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <IconComponent
              icon={MailIcon}
              style={{ fontSize: "22px", color: "#ffffff" }}
            />
          </div>

          <div>
            <h2
              style={{
                margin: 0,
                fontSize: "19px",
                fontWeight: 700,
                color: "#ffffff",
                letterSpacing: "-0.02em",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              Bulk Email
            </h2>
            <p
              style={{
                margin: "2px 0 0 0",
                fontSize: "12px",
                color: "#ffffff",
                fontWeight: 400,
              }}
            >
              Send personalized emails with real-time variable mapping
            </p>
          </div>
        </div>
      </div>
    </ShadowCard>
  );
};
